function createPolymorphicComponent(component) {
  return component;
}

export { createPolymorphicComponent };